import getUserLocale from 'get-user-locale';
export var formatHour = function formatHour(locale, hour) {
  return hour.toLocaleString(locale || getUserLocale());
};